
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          email: string | null;
          full_name: string | null;
          avatar_url: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email?: string | null;
          full_name?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          email?: string | null;
          full_name?: string | null;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      qr_codes: {
        Row: {
          id: string;
          user_id: string;
          name: string;
          url: string;
          qr_image: string | null;
          scans: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          name: string;
          url: string;
          qr_image?: string | null;
          scans?: number;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          name?: string;
          url?: string;
          qr_image?: string | null;
          scans?: number;
          created_at?: string;
          updated_at?: string;
        };
      };
      short_links: {
        Row: {
          id: string;
          user_id: string;
          name: string;
          original_url: string;
          short_code: string;
          clicks: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          name: string;
          original_url: string;
          short_code: string;
          clicks?: number;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          name?: string;
          original_url?: string;
          short_code?: string;
          clicks?: number;
          created_at?: string;
          updated_at?: string;
        };
      };
      bio_links: {
        Row: {
          id: string;
          user_id: string;
          username: string;
          title: string;
          bio: string | null;
          avatar_url: string | null;
          links: Array<{ title: string; url: string; icon?: string }>;
          views: number;
          theme: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          username: string;
          title: string;
          bio?: string | null;
          avatar_url?: string | null;
          links?: Array<{ title: string; url: string; icon?: string }>;
          views?: number;
          theme?: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          username?: string;
          title?: string;
          bio?: string | null;
          avatar_url?: string | null;
          links?: Array<{ title: string; url: string; icon?: string }>;
          views?: number;
          theme?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};
